export default __webpack_public_path__ + "569c0a6e228880994212155b9cea3578.jpg";